angular.module('rjmNg.directives').directive "highlightAndShake", [
  "$parse"
  "$timeout"
  "$location"
  "$anchorScroll"
  "$window"
  ($parse, $timeout, $location, $anchorScroll, $window) ->
    restrict: "A"
    link: (scope, element, attrs, controller) ->
      getter = $parse(attrs.highlightAndShake)
      if +$location.hash() is getter(scope)
        #we timeout here so the anchorScroll happens after any other visual changes.
        $timeout ->
          $anchorScroll()
          $window.scrollBy(0, -100)
          element.addClass("highlight")
          $timeout ->
            element.removeClass("highlight")
          , 5000
        , 1000
]
